/* global ga */
import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter  } from 'react-router-redux';
import ScrollToTop from 'components/common/ScrollToTop';
import Spinner from 'components/common/Spinner';

import Layout from 'components/Layout';
import routes from 'routes';


export default class App extends React.Component {

  componentDidMount() {
    const overlay = document.querySelector("body > .loading-overlay");
    overlay.parentNode.removeChild(overlay);

    this.props.onLoad(window.innerWidth);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.gaTrackingCode && nextProps.gaTrackingCode) {
      ga('create', nextProps.gaTrackingCode, 'auto');
      ga('send', 'pageview');
    }
  }

  render() {
    const { isFetching, history } = this.props;
    if (isFetching) {
      return <div className="loading-overlay">
        <Spinner/>
      </div>;
    }

    const routeElements = routes.map((route,i) => (
      <Route key={i} exact path={route.path} component={route.component} />
    ));

    return (
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <Layout>
            {routeElements}
          </Layout>
        </ScrollToTop>
      </ConnectedRouter>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/App.js